var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgUnlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.917,
    height: 17.965,
    viewBox: "0 0 17.917 17.965"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-unlink_svg__cls-1{fill:#009ceb;stroke:#009ceb;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.1px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-unlink_svg__ICN_Disociaza_Enabled",
    transform: "translate(-337.868 -249.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-unlink_svg__Group_979",
    "data-name": "Group 979",
    transform: "translate(336 247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-unlink_svg__Group_2547",
    "data-name": "Group 2547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-unlink_svg__Path_847",
    "data-name": "Path 847",
    className: "kpmg-unlink_svg__cls-1",
    d: "M362.767 250.647a3.462 3.462 0 00-5 0l-2.707 2.789a.31.31 0 000 .43.289.289 0 00.417 0l2.706-2.791a2.891 2.891 0 014.164 0 3.111 3.111 0 010 4.292l-3.539 3.648a2.889 2.889 0 01-4.165 0 .287.287 0 00-.416 0 .309.309 0 000 .428 3.462 3.462 0 005 0l3.54-3.649a3.731 3.731 0 000-5.149zm0 0",
    transform: "translate(-344.563 -246.933)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-unlink_svg__Path_848",
    "data-name": "Path 848",
    className: "kpmg-unlink_svg__cls-1",
    d: "M346.007 270.44l-2.321 2.312a2.977 2.977 0 01-4.219-4.2l3.375-3.362a3 3 0 014.219 0 .3.3 0 00.423-.421 3.594 3.594 0 00-5.064 0l-3.376 3.363a3.573 3.573 0 005.062 5.044l2.321-2.312a.3.3 0 10-.421-.421zm0 0",
    transform: "translate(.418 -7.745)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-unlink_svg__Group_2545",
    "data-name": "Group 2545",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-unlink_svg__Path_852",
    "data-name": "Path 852",
    className: "kpmg-unlink_svg__cls-1",
    d: "M350.29 254.529a.317.317 0 00.316-.318v-1.905a.317.317 0 10-.634 0v1.905a.318.318 0 00.317.318zm0 0",
    transform: "translate(-6.803 -3.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-unlink_svg__Path_853",
    "data-name": "Path 853",
    className: "kpmg-unlink_svg__cls-1",
    d: "M345.01 256.884a.317.317 0 00.45-.448l-1.347-1.347a.317.317 0 10-.45.448zm0 0",
    transform: "translate(-3.942 -5.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-unlink_svg__Path_854",
    "data-name": "Path 854",
    className: "kpmg-unlink_svg__cls-1",
    d: "M341.49 262.223h1.905a.317.317 0 000-.634h-1.905a.317.317 0 100 .634zm0 0",
    transform: "translate(-2.495 -8.175)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-unlink_svg__Group_2546",
    "data-name": "Group 2546",
    transform: "translate(349.677 260.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-unlink_svg__Path_852-2",
    "data-name": "Path 852",
    className: "kpmg-unlink_svg__cls-1",
    d: "M350.289 251.988a.317.317 0 00-.316.318v1.9a.317.317 0 10.634 0v-1.9a.318.318 0 00-.317-.318zm0 0",
    transform: "translate(-349.973 -249.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-unlink_svg__Path_853-2",
    "data-name": "Path 853",
    className: "kpmg-unlink_svg__cls-1",
    d: "M344.113 255.089a.317.317 0 00-.45.448l1.347 1.347a.317.317 0 00.45-.448zm0 0",
    transform: "translate(-341.378 -252.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-unlink_svg__Path_854-2",
    "data-name": "Path 854",
    className: "kpmg-unlink_svg__cls-1",
    d: "M343.393 261.589h-1.9a.317.317 0 000 .634h1.9a.317.317 0 100-.634zm0 0",
    transform: "translate(-338.585 -261.589)"
  })))));
}

export default SvgKpmgUnlink;